import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import { changeNum } from './common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function SnsSetting() {
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    let dark = useSelector((state) => { return state.Darkmode.value });

    const [data, setData] = useState([
        { id: 1, name: "유튜브", link: "", active: true },
        { id: 2, name: "텔레그램", link: "", active: true },
        { id: 3, name: "트위터", link: "", active: true },
    ])

    const [changeValue, setChangeValue] = useState(false)

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        // UpgradeData()
    }, [reload])

    const [inputValues, setInputValues] = useState([]);

    useEffect(() => {
        if (data?.length) {
            setInputValues(data.map((item) => ({ id: item.id, value: item.value })));
        }
    }, [data]);

    const handleInputChange = (id, value) => {
        setInputValues((prev) =>
            prev.map((item) => (item.id === id ? { ...item, value } : item))
        );
    };

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/setting', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                console.log(tmp)
                setData(tmp?.data?.setting ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    const onSubmitUpdate = async () => {
        // await axios.post(process.env.REACT_APP_API + '/api/setting', {
        //     settings: inputValues
        // }, {
        //     // headers: { Authorization: `Bearer ${JWT}` }
        // }).then((response) => {
        //     let tmp = response.data
        //     if (tmp?.code == 1000) {
        //         setChangeValue(false)
        //         setReload(e => !e)
        //     }
        // }).catch((error) => {
        //     console.log(error)
        // })
    };

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`} style={{ width: "1200px" }}>
                <div className='table-flex'>
                    <div className={`member-2 ${darkname}`} style={{width:"650px"}}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "10%", minWidth: "50px" }}>no.</div>
                            <div style={{ width: "15%", minWidth: "100px" }}>SNS</div>
                            <div style={{ width: "30%", minWidth: "400px" }}>링크</div>
                            <div style={{ width: "10%", minWidth: "100px" }}>활성화</div>
                        </div>
                        <div className='table-body' style={{ minHeight: "150px" }}>
                            {
                                spinner
                                    ?
                                    <div className='spinner-modal'>
                                        <SyncLoader color="#003577" />
                                    </div>
                                    :
                                    data.length === 0
                                        ?
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png'></img>
                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                        :
                                        <>
                                            {
                                                data.map(function (a, i) {
                                                    return (
                                                        <MemberItem
                                                            key={i}
                                                            item={a}
                                                            seq={i + 1} // 역순 계산
                                                            darkname={darkname}
                                                            dark={dark}
                                                            changeValue={changeValue}
                                                            handleInputChange={handleInputChange}
                                                        />
                                                    )
                                                })
                                            }
                                        </>
                            }
                        </div>
                        <div className='gameSetting-btn-1'>
                            {
                                changeValue
                                    ?
                                    <>
                                        <div className='gameSetting-btn-2' onClick={() => setChangeValue(false)}>취소</div>
                                        <div className='gameSetting-btn-2' onClick={() => onSubmitUpdate()}>저장</div>
                                    </>
                                    :
                                    <div className='gameSetting-btn-2' onClick={() => setChangeValue(true)}>수정</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, seq, darkname, dark, changeValue, handleInputChange }) {
    const [inputValue, setInputValue] = useState(item.link);

    const onChangeFirstValue = (e) => {
        const { value } = e.target.value;
        setInputValue(value)
    };
    
    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="td" style={{ width: "10%", minWidth: "50px" }}>{item.id}</div>
                <div className="td" style={{ width: "15%", minWidth: "100px" }}>{item.name}</div>
                {
                    changeValue
                        ?
                        <div className="td" style={{ width: "30%", minWidth: "400px", display: "flex", gap: "5px" }}>
                            <input
                                value={inputValue}
                                onChange={onChangeFirstValue}
                                style={{ width: "80%", padding: "3px" }}
                            />
                        </div>
                        :
                        <div className="td" style={{ width: "30%", minWidth: "400px" }}>
                            {item.link}
                        </div>
                }
                <div className="td" style={{ width: "10%", minWidth: "100px" }}>{item.active?"활성화":"비활성화"}</div>
            </div>
        </>
    );
}

export default SnsSetting;